export const closeRtcTracks = (localStream) => {

  if (localStream) {

    var track = localStream.getTracks().forEach(track => {

      console.log("closing track", track)
      track.stop()
    })

  }

}

/**************************************************************************************/

export const initPeerConnection = (props) => {

  var {sendCanidateInfo, localStream, onTrack, remoteSession, twilioConfig} = props;

  const localPeerConnection = new RTCPeerConnection(twilioConfig);
  console.log({
    localStream
  })

  if (localStream) {

    localStream.getTracks().forEach(track => localPeerConnection.addTrack(track, localStream));

  }

  localPeerConnection.ontrack = (event) => {
    // don't set srcObject again if it is already set.

    if (onTrack) {
      onTrack({
        defaultStream: event.streams[0],
        event,
        streams: event.streams
      });
    }

  };

  if (remoteSession) {

    return setRemoteDescription(localPeerConnection, remoteSession)

      .then((remoteSession) => {

        return createAnswer(localPeerConnection)

      })

      .then((desc) => {

        return setLocalDescriptioin(localPeerConnection, desc);

      })

      .then(() => {

        return getIceCanidates(localPeerConnection)

      })

      .then((localPeerConnection) => {

        return {
          localPeerConnection,
        }

      })

  } else {

    return localPeerConnection.createOffer(localPeerConnection)

      .then((desc) => {

        return setLocalDescriptioin(localPeerConnection, desc);

      })

      .then(() => {

        return getIceCanidates(localPeerConnection)

      })

      .then((localPeerConnection) => {

        return {
          localPeerConnection,
        }

      })

  } //

}

export const initPeerConnectionWithTwiiloTurn = (props) => {

  return getTwillioTurnConfig()

    .then((twilioConfig) => {

      return initPeerConnection({
        ...props,
        twilioConfig
      })

    })

}

const getTwillioTurnConfig = () => {

  var getTwillioTurnConfigUrl = "https://us-central1-fire-jitsu-chat.cloudfunctions.net/getTwillioTurnConfig"

  return fetch(getTwillioTurnConfigUrl).then(res => res.json())

}


const setRemoteDescription = (localPeerConnection, desc) => {

  return localPeerConnection.setRemoteDescription(desc).catch(onSetSessionDescriptionError)

}


export const createAnswer = (peerConnection) => {

  return peerConnection.createAnswer()

    .catch(onCreateSessionDescriptionError)

}

export const createOffer = (peerConnection) => {

  return peerConnection.createOffer()

    .catch(onCreateSessionDescriptionError)

}

const setLocalDescriptioin = (localPeerConnection, desc) => {

  return localPeerConnection.setLocalDescription(desc).catch(onSetSessionDescriptionError)

}

const onSetLocalSuccess = (localPeerConnection) => {
  console.log(` setLocalDescription complete`), localPeerConnection;

  //var {user, messaginScreen: {id, messages}, sendMessage} = props;

}

/**************************************************************************************/

const getIceCanidates = (localPeerConnection) => {

  return new Promise(resolve => {
    localPeerConnection.addEventListener('icegatheringstatechange', event => {
      if (event.target.iceGatheringState === 'complete') {
        resolve(localPeerConnection);
      }
    });
  });
}


const watchForCanidates = (props) => {

  var {localPeerConnection, sendCanidateInfo} = props

  localPeerConnection.oniceconnectionstatechange = e => onIceStateChange(localPeerConnection, e);

  localPeerConnection.onicecandidate = (candidateEvent) => {
    if (sendCanidateInfo) {

      sendCanidateInfo({
        candidateEvent
      })
    }

  }

}

const onIceCandidate = (event) => {
  // getOtherPc(pc).addIceCandidate(event.candidate)
  //   .then(() => this.onAddIceCandidateSuccess(pc), err => this.onAddIceCandidateError(pc, err));

}


const onIceStateChange = (pc, event) => {
  if (pc) {
    console.log(`${(pc)} ICE state: ${pc.iceConnectionState}`);
    console.log('ICE state change event: ', event);
  }
}

/**************************************************************************************/

const onAddIceCandidateSuccess = (pc) => {
  console.log(`${(pc)} addIceCandidate success`);
}

/**************************************************************************************/







/**************************************************************************************/

const onAddIceCandidateError = (pc, error) => {
  console.log(`${(pc)} failed to add ICE Candidate: ${error.toString()}`);
}

const onSetSessionDescriptionError = (error) => {
  console.log(`Failed to set session description: ${error.toString()}`);
}

const onCreateSessionDescriptionError = (error) => {

  console.log('onCreateSessionDescriptionError', error)

}
/**************************************************************************************/



// WEBPACK FOOTER //
// ./src/Components/JitsuFlyerView/rtcUtils.js